<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="lucide lucide-info w-6 h-6 text-cyan-400"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M12 16v-4" />
    <path d="M12 8h.01" />
  </svg>
</template>

<script setup>
// Info icon component
</script>

<style scoped>
.lucide-info {
  display: inline-block;
  vertical-align: middle;
  width: 1.5rem; /* w-6 */
  height: 1.5rem; /* h-6 */
  color: #22d3ee; /* text-cyan-400 */
}
</style>
